import { WS_EVENT } from '../constants/list';

export function updateWsEvent(wsEvent) {

  return {
    type: WS_EVENT,
    payload: wsEvent
  }

}